export default __webpack_public_path__ + "static/media/ic-percursos-pedestres.1b3d783a.svg";